import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const MatchList = ({ title, matches }) => (
  <Wrapper>
    <Header>{title}</Header>
    {matches.length === 0 ? (
      <Empty>No hay partidas</Empty>
    ) : (
      <Grid>
        {matches.map((match) => (
          <MatchCard key={match.matchId} to={`/match/${match.matchId}/detail`}>
            <MatchDay>J{match.leagueDay}</MatchDay>
            <MatchPlayers>
              <PlayerName $win={match.playerAresult > match.playerBresult || match.playerAaw === "AW"}>
                {match.playerAusername}
              </PlayerName>
              <VS>vs</VS>
              <PlayerName $win={match.playerBresult > match.playerAresult || match.playerBaw === "AW"}>
                {match.playerBusername}
              </PlayerName>
            </MatchPlayers>
            {match.matchDate && (
              <MatchDate>
                {new Date(match.matchDate).toLocaleDateString("es-ES", {
                  day: "numeric",
                  month: "short",
                })}
              </MatchDate>
            )}
          </MatchCard>
        ))}
      </Grid>
    )}
  </Wrapper>
);

const Wrapper = styled.div`
  margin-top: 1rem;
`;

const Header = styled.h4`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--v-fg-muted);
  margin: 0 0 0.5rem;
`;

const Empty = styled.p`
  font-family: var(--v-font-body);
  font-size: 13px;
  color: var(--v-fg-muted);
`;

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const MatchCard = styled(Link)`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.6rem 0.85rem;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  text-decoration: none;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: rgba(60, 255, 208, 0.12);
    background: rgba(60, 255, 208, 0.02);
  }
`;

const MatchDay = styled.span`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  color: var(--v-fg-muted);
  min-width: 2.2rem;
`;

const MatchPlayers = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
`;

const PlayerName = styled.span`
  font-family: var(--v-font-body);
  font-size: 13px;
  font-weight: ${({ $win }) => ($win ? 700 : 400)};
  color: ${({ $win }) => ($win ? "var(--v-mint)" : "var(--v-fg)")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const VS = styled.span`
  font-family: var(--v-font-mono);
  font-size: 9px;
  color: var(--v-fg-muted);
  flex-shrink: 0;
`;

const MatchDate = styled.span`
  font-family: var(--v-font-mono);
  font-size: 10px;
  color: var(--v-fg-muted);
  flex-shrink: 0;
`;

export default MatchList;
